.header {
  font-family: var(--vrf-font-family);
  --vrf-font-color: #fff !important;
}

.header-title {
  font-weight: 100;
  font-size: 24px;
  line-height: 25px;
  display: flex;
  align-items: center;
  padding-left: 16px;
}

.header-contents {
  display: flex;
  margin: 0px 0px 0px auto;
}

.header-user-info {
  font-weight: 100;
  font-size: 18px;
  line-height: 25px;
  display: flex;
  align-items: center;
  text-align: right;
  margin-right: 16px;
}

.header-user-id {
  margin-right: 8px;
  margin-left: 8px;
}

.header-manual {
  font-weight: 100;
  font-size: 18px;
  line-height: 25px;
  display: flex;
  align-items: center;
  text-align: right;
  margin-right: 16px;
}

.header-manual-link ::part(single-link) {
  font-weight: 100;
  font-size: 18px;
  color: #fff;
}
